"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withColors;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper to output the foreground and background colors given
 * a Color value.
 */
function withColors(color) {
  return (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _toColorString.default)(color), (0, _toColorString.default)(color.fg));
}